import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Overlay } from '../../../../../../htwevents/Resources/Private/JavaScript/CrmFormWorkshops/Containers/Overlay';
import Semester from './Semester';
import Start from './Start';
import OverlayFooter from './OverlayFooter';
import Overview from './Overview';
import { getStorage, setSession, setStudyplanId } from '../Util/Module';
import Info from './Info';
import { localize } from '../Util/L10n';
import Link, { getPath } from '../Util/Paths';
import { changeStateMobileAccordeon } from '../Containers/App';
import iconArrow from '../../../../Public/Icons/icon-arrow.svg';
import iconClose from '../../../../Public/Icons/icon-close.svg';

class StudyOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedModules: this.getSelectedModules(props),
    };
  }

  /**
   * Handles the ?module=something query string as an entry point
   *
   * @param props
   * @returns {any|[]}
   */
  getSelectedModules = (props) => {
    const module = new URLSearchParams(props.location.search).get('module');
    if (module) {
      const modules = JSON.parse(atob(module));
      setSession(modules);
      return modules;
    } else {
      setStudyplanId(props.studyplan.uid);
      return getStorage();
    }
  };

  prev = (match) => {
    let { studyplan, semester } = match.params;
    if (match.path === getPath('overview')) {
      semester = this.props.studyplan.semesters.length + 1;
    }

    if (semester > 1) {
      if (this.hasCoreElectiveModules(semester - 2) && match.isExact) {
        return getPath('compulsory', {
          studyplan,
          semester: semester - 1,
        });
      } else if (match.isExact) {
        return getPath('semester', {
          studyplan,
          semester: semester - 1,
        });
      } else {
        return getPath('semester', { studyplan, semester });
      }
    } else {
      return getPath('start', { studyplan });
    }
  };
  prevButton(routerProps) {
    return (
      <Link to={this.prev(routerProps.match)}>
        <img src={iconArrow} />
      </Link>
    );
  }
  historyBackButton = () => {
    return (
      <a
        href=""
        onClick={(e) => {
          e.preventDefault();
          this.props.history.goBack();
        }}
      >
        <img src={iconArrow} />
      </a>
    );
  };
  getSemester = (semester) => {
    return this.props.studyplan.semesters[semester];
  };
  setModules = (semester, modules) => {
    this.setState({
      selectedModules: {
        ...this.state.selectedModules,
        [semester]: modules,
      },
    });
  };
  getCoreElectiveModules = (semester) => {
    return this.getSemester(semester).modules.filter(
      (module) => module.placeholderType === 1
    );
  };
  hasCoreElectiveModules = (semester) => {
    return this.getCoreElectiveModules(semester).length > 0;
  };
  hasAllCoreElectiveModules = (semester) => {
    const modules = this.getCoreElectiveModules(semester);
    try {
      const selected = Object.values(
        this.state.selectedModules[semester + 1]
      ).filter((v) => v).length;
      return selected === modules.length;
    } catch {
      return false;
    }
  };
  getNextButton = (semester, match) => {
    const { studyplan } = match.params;
    const hasElective = this.hasCoreElectiveModules(semester);

    if (hasElective && match.isExact) {
      return (
        <Link to={`${match.url}/compulsory`} className="btn btn-primary">
          {localize('chooseModule')}
        </Link>
      );
    } else if (
      semester === this.props.studyplan.semesters.length - 1 &&
      (!hasElective ||
        (hasElective && this.hasAllCoreElectiveModules(semester)))
    ) {
      return (
        <Link to="overview" params={{ studyplan }} className="btn btn-primary">
          {localize('toOverview')}
        </Link>
      );
    } else if (
      (!hasElective && semester < this.props.studyplan.semesters.length - 1) ||
      (hasElective && this.hasAllCoreElectiveModules(semester))
    ) {
      return (
        <Link
          to="semester"
          params={{ studyplan, semester: semester + 2 }}
          className="btn btn-primary"
        >
          {localize('goToSemester', this.getSemester(semester + 1).name)}
        </Link>
      );
    }
  };
  getModuleById = (id) => {
    const modules = this.props.studyplan.semesters
      .map((semesters) => semesters.modules)
      .flat();
    const coreElectiveModules = modules
      .filter((module) => module.placeholderType === 1)
      .map((module) => module.coreElectiveModules)
      .flat();
    modules.push(...coreElectiveModules);
    return modules.find((module) => module.uid === parseInt(id));
  };

  render() {
    return (
      <Overlay class="overlay">
        <div className="header row row--with_margin align-items-center">
          <div className="col-auto">
            <Route
              path={getPath('semester')}
              render={(routerProps) => {
                return this.prevButton(routerProps);
              }}
            />
            <Route
              path={getPath('overview')}
              render={(routerProps) => {
                return this.prevButton(routerProps);
              }}
            />
            <Route
              path={getPath('info')}
              render={() => {
                return this.historyBackButton();
              }}
            />
          </div>
          <div className="col text-center font-weight-bold">
            <Switch>
              <Route
                path={getPath('semester')}
                render={(routerProps) => {
                  return this.props.studyplan.semesters[
                    routerProps.match.params.semester - 1
                  ].name;
                }}
              />
              <Route path={getPath('overview')}>{localize('overview')}</Route>
            </Switch>
          </div>
          <div className="col-auto">
            <Switch>
              <Route path={getPath('info')} />
              <Route>
                <Link
                  className="btn btn-link"
                  type="button"
                  to="/"
                  onClick={() => changeStateMobileAccordeon(false)}
                >
                  <img src={iconClose} />
                </Link>
              </Route>
            </Switch>
          </div>
        </div>
        <div className="content-wrapper">
          <div className="content">
            <Switch>
              <Route path={getPath('start')}>
                <Start
                  imageUrl={this.props.studyplan.images[0]}
                  descriptionHtml={this.props.studyplan.description}
                />
              </Route>
              <Route
                path={getPath('semester')}
                render={(routerProps) => {
                  const semester = this.getSemester(
                    routerProps.match.params.semester - 1
                  );
                  return (
                    <Semester
                      semester={semester}
                      onModuleChange={this.setModules}
                      selectedModules={this.state.selectedModules}
                    />
                  );
                }}
              />
              <Route
                path={getPath('info')}
                render={(routerProps) => {
                  return (
                    <Info
                      module={this.getModuleById(
                        routerProps.match.params.module
                      )}
                    />
                  );
                }}
              />
              <Route path={getPath('overview')}>
                <Overview
                  studyplan={this.props.studyplan}
                  semesters={this.props.studyplan.semesters}
                  selectedModules={this.state.selectedModules}
                />
              </Route>
            </Switch>
          </div>
        </div>

        <Switch>
          <Route
            path={getPath('semester')}
            render={(routerProps) => {
              return (
                <OverlayFooter>
                  <div className="button-wrapper col-12 col-md-auto ml-auto">
                    {this.getNextButton(
                      routerProps.match.params.semester - 1,
                      routerProps.match
                    )}
                  </div>
                </OverlayFooter>
              );
            }}
          />
        </Switch>
      </Overlay>
    );
  }
}

export default withRouter(StudyOverlay);
